<template>
  <div class="pt-3 pl-4 overflow-auto" style="max-height:640px">
    <div v-if="listType == 'table'" class="card p-3">
      <div  class="table-responsive mb-0" style="overflow-x: auto;">
        <customTable 
          :items="items"
          :fields="fields"
          @sort-changed="sortChanged"
          moduleName="job"
        />
      </div>
    </div>
    <div
      v-else
      v-for="(item, idx) in items"
      :key="idx"
    >
      <b-card class="job-card-item" no-body style="padding-inline: 20px; padding-bottom: 20px;">
        <b-row align-h="between">
          <b-col cols="10" class="pt-3">
            <span v-if="!companyID && role_modules.some(item => item.value == 'company.view')" class="company_name">
              <button 
                class="btn2 btn2-tertiary btn2-md"
                @click="onViewCompany(item.company_id._id, item._id)"
                style="padding-left: 0px !important;"
              >
                {{item.company_id.name}}
              </button>
            </span>
            <span v-else class="company_name">
              {{ item.company_id.name }}
            </span>
          </b-col>
          <b-card-text>
            <div 
              class="text-right d-flex flex-column justify-content-start align-items-end setting_dropdown_container"
            >
              <input readonly hidden id="copyURL" ref="copyURL" v-if="role_modules.some(item => item.value == 'job.generate_url')" v-model="item.job_url">
              <input readonly hidden id="copyCompanyURL" ref="copyCompanyURL" v-if="role_modules.some(item => item.value == 'job.generate_url')" v-model="item.job_company_url">

              <b-dropdown
                variant="black"
                class=""
                dropleft 
                text="Drop-Left"
                v-if="user.access_type !== 'candidate'"
              >
                <template v-slot:button-content>
                  <button 
                    id="setting"
                    class="btn2 btn2-tertiary h1 my-0 py-0 text-muted font-weight-bolder"
                    v-if="role_modules.some(item => item.value == 'job.generate_url') || role_modules.some(item => item.value == 'job.submit_candidate')"
                  >
                    ...
                  </button>
                  <b-tooltip target="setting" placement="top">Setting</b-tooltip>
                </template>
                <!-- item-->
                <b-dropdown-item 
                  href="javascript:void(0);"
                  class="notify-item"
                  @click="urlGenerate(item._id, false)"
                  v-if="!item.job_url && role_modules.some(item => item.value == 'job.generate_url')  && !companyID"
                >
                  <i class="uil uil-link-alt mr-1" />
                  Generate URL
                </b-dropdown-item>
                <b-dropdown-item 
                  href="javascript:void(0);"
                  class="notify-item"
                  @click="onCopyUrl(item.job_url)"
                  v-if="item.job_url && role_modules.some(item => item.value == 'job.generate_url')  && companyID"
                >
                  <i class="uil uil-copy mr-1" />
                  Copy URL
                </b-dropdown-item>
                <b-dropdown-item 
                  href="javascript:void(0);"
                  class="notify-item"
                  @click="urlGenerate(item._id, true)"
                  v-if="!item.job_company_url && role_modules.some(item => item.value == 'job.generate_url')" 
                >
                  <i class="uil-file-copy-alt mr-1" />
                  {{ role_modules.some(item => item.value == 'job.generate_url') && !companyID ? 'Generate Company URL' : 'Generate URL' }}
                </b-dropdown-item>
                <b-dropdown-item 
                  href="javascript:void(0);"
                  class="notify-item"
                  @click="onCopyUrl(item.job_company_url)"
                  v-if="role_modules.some(item => item.value == 'job.generate_url') && item.job_company_url"
                >
                  <i class="uil-copy-alt mr-1" />
                  {{ role_modules.some(item => item.value == 'job.generate_url') && !companyID ? 'Copy Company URL' : 'Copy URL' }} 
                </b-dropdown-item>
                <b-dropdown-item 
                  href="javascript:void(0);"
                  class="notify-item"
                  @click="onReferCandidate(item._id)"
                  v-if="item.active && (item.slots - item.hired) > 0 && role_modules.some(item => item.value == 'job.submit_candidate')"
                >
                  <i class="uil-message mr-1" />
                  {{ $t('job.action.submit_candidate') }}
                </b-dropdown-item>
                <b-dropdown-item 
                  href="javascript:void(0);"
                  class="notify-item"
                  @click="onReferCandidate(item._id)"
                  v-if="item.active && (item.slots - item.hired) > 0 && role_modules.some(item => item.value == 'job.submit_application')"
                >
                  <i class="uil-message mr-1" />
                  Submit Application
                </b-dropdown-item>
                <b-dropdown-item 
                  href="javascript:void(0);"
                  class="notify-item"
                  v-if="user.role.role == 'administration' && role_modules.some(item => item.value == 'job.activate')"
                  @click="onActivate(item)"
                >
                  <i
                    class="mr-1"
                    :class="item.active ? 'uil-times-circle' : 'uil-check-circle'" 
                  />
                  {{ !item.active ? $t('job.action.activate') : $t('job.action.deactivate') }}
                </b-dropdown-item>
                <b-dropdown-item 
                  href="javascript:void(0);"
                  class="notify-item"
                  v-if="role_modules.some(item => item.value == 'job.post')"
                  @click="onPublish(item)"
                >
                  <i
                    class="mr-1"
                    :class="item.published ? 'uil-file-times' : 'uil-file-check'"
                  />
                  {{ !item.published ? 'Post' : 'Unpost' }}
                </b-dropdown-item>
                <b-dropdown-item 
                  href="javascript:void(0);"
                  class="notify-item"
                  v-if="user.role.role == 'administration' && !item.published"
                  @click="onClickEdit(item._id)"
                >
                   <i class="uil uil-edit mr-1" />
                   {{ $t('common.edit') }}
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </b-card-text>
        </b-row>
        
        <b-row align-h="between">
          <b-col>
            <span class="header">
              <button 
                class="btn2 btn2-tertiary h4 my-0"
                @click="$emit('onView', item._id)"
                v-if="role_modules.some(item => item.value == 'job.view')"
                style="padding: 0px !important;"
              >
                {{ item.title }}
              </button>
              <a4 v-else>{{ item.title }}</a4>
              <b-badge variant="light" class="ml-2 badge-matched">{{ item.status }}</b-badge>
              <b-badge variant="light" class="ml-2 badge-soft-secondary"
                v-if="!item.published && !item.posted"
              >Draft</b-badge>
              <b-badge variant="light" class="ml-2 badge-soft-danger"
                v-else-if="!item.published && item.posted"
              >Unposted</b-badge>
              <b-badge variant="light" class="ml-2 badge-soft-primary"
                v-else
              >Posted</b-badge>
            </span>
            <span class="ml-2 text-right badge badge-pill badge-danger"
              v-if="!item.active"
            >Deactivated</span>
            <span class="ml-2 text-right badge badge-pill badge-danger"
              v-if="item.title_changed"
            >Title Changed</span><span class="ml-2 text-right badge badge-pill badge-danger"
              v-if="item.description_changed"
            >Description Changed</span>
            <div class="ml-1" style="font-size: 11px" v-if="item.ats_id">{{ item.ats_id }}</div>
            <div class="ml-1" style="font-size: 11px" v-if="item.updatedAt || item.createdAt">
              {{item.updatedAt ? 'Updated' : 'Created'}} {{ modifiedJobDate(item.updatedAt || item.createdAt) }}
            </div>
          </b-col>
        </b-row>

        <b-row align-h="between">
          <b-col class="small_text mt-3 text-truncate" style="max-height: 100px;">
            <div v-if="item.summary" v-html="item.summary"></div>
            <div v-else> - </div>
          </b-col>
  
          <b-card-text class="header pr-5 mr-4">
            {{ (item.min_salary ? item.min_salary.$numberDecimal : 0) || 0 | currency(item.currency_id.symbol, item.currency_id.symbol == '¥' ? 0 : 2)}}
            -
            {{ (item.max_salary ? item.max_salary.$numberDecimal : 0) || 0 | currency(item.currency_id.symbol, item.currency_id.symbol == '¥' ? 0 : 2)}}
          </b-card-text>
        </b-row>

        <b-row align-h="between">
          <div class="ml-2">
            <!-- <span class="h6">
              <b-badge class="mr-3" variant="light">New</b-badge>
              <b-badge class="mr-3" variant="light">Fee: 40%</b-badge>
              <b-badge class="mr-3" variant="light">Urgent</b-badge>
              <b-badge class="mr-3" variant="light">No Experience Required</b-badge>
              <b-badge class="mr-3" variant="light">Full Remote</b-badge>
            </span> -->
          </div>
          <div>
            <!-- <span class="company_name">
              <router-link
                tag="a"
                to=""
                @click.native="$emit('onView', item._id)"
              >
                Expand
              </router-link>
            </span> -->
          </div>
          <!-- <b-button 
            size="sm" 
            variant="secondary" 
            @click="onReferCandidate(item._id)"
            v-if="item.active && (item.slots - item.hired) > 0 "
          >
            Refer Candidate
          </b-button> -->
        </b-row>
        <!-- <a href="#" class="card-link">Card link</a>
        <b-link href="#" class="card-link">Another link</b-link> -->
        <b-row align-h="between">
          <button type="button" class="btn2 btn2-tertiary btn2-md ml-2" style="padding: 0 !important; font-weight: 600;" @click="$emit('onView', item._id)">
            <b-badge variant="light">Show more</b-badge>
          </button>
        </b-row>
      </b-card>
    </div>
    

    <OffCanvas
      centered
      size="lg"
      customClass="customDialog"
      ref="submitCandidate"
      :title="`Submit a ${moduleName}`"
      :component="submitCandidateComponent"
      @onClick="onClickActions"
    />
    <OffCanvas
      centered
      size="lg"
      ref="modeSelect"
      hideHeader
      customClass="customDialog"
      title="Select a Candidate"
      :component="selectCandidateComponent"
      :parameters="{ candidates }"
      @onClick="onClickActions"
    />
    <OffCanvas
      title="View Candidate"
      centered
      ref="viewCandidate"
      size="xl"
      bodyClass="modalBodyContainer px-4"
      :component="viewCandidateComponent"
      :parameters="{ candidateID }"
      @onClick="onClickActions"
    />
    <OffCanvas
      centered
      size="lg"
      ref="createCandidate"
      customClass="customDialog"
      :title="`${candidateID ? 'Edit Candidate' : `Apply with New ${moduleName}`}`"
      :component="createCandidateComponent"
      :parameters="{ finalModel, is_wizard_manual_reset, candidateID }"
      @onClick="onClickActions"
    />
    <OffCanvas
      centered
      size="lg"
      ref="uploadCandidate"
      customClass="customDialog"
      title="Upload a Candidate"
      :component="uploadCandidateComponent"
      :parameters="{ finalModel, is_reset_wizard, is_wizard_upload_reset }"
      @onClick="onClickActions"
    />
    <Dialog
      centered
      size="lg"
      ref="modalError"
      title="Warning"
      bodyMessage="Candidate already exists on our system. We have forwarded the info to admin and Jinz.ai admin will contact you directly"
      noText="Close"
    />

    <OffCanvas
      width="1200"
      autoload
      centered
      title="Company"
      size="xl"
      ref="viewCompany"
      bodyClass="modalBodyContainer px-4"
      :parameters="{ submitted, rowId }"
      :component="viewCompanyComponent"
      @onClick="onClickActions"
    />

    <OffCanvas
      customBtnClass="component-custom"
      width="1200"
      reload
      centered
      title="Update Company"
      size="xl"
      :buttonDisable="updated"
      ref="updateCompany"
      yesText="Update"
      noText="Cancel"
      :parameters="{ rowId, submitted }"
      :component="updateCompanyComponent"
      @onYes="onUpdateCompany"
    />

    <Dialog
      centered
      size="md"
      ref="showGeneratedURL"
      title="Generated URL"
      :component="jobURL"
      :parameters="{ job_url: job_param_url }"
    />
  </div>
</template>

<script>
import FormMixin from '@mixins/form'
import Dialog from '@components/dialogs'
import OffCanvas from '@components/offcanvas'
import error from '@utils/error'
import moment from 'moment-timezone'
import customTable from '../../../components/tables/customTable.vue'
import { mapState } from 'vuex'


export default {
  mixins: [ FormMixin ],
  components: {
    Dialog,
    OffCanvas,
    customTable
  },
  props:{
    items: Array,
    companyID: String,
    listType: String
  },
  computed: {
    submitCandidateComponent() {
      return () => import('@pages/job/components/dialogs/submitCandidate.vue')
    },
    selectCandidateComponent() {
      return () => import('@pages/job/components/dialogs/selectCandidate.vue')
    },
    createCandidateComponent() {
      return () => import('@pages/job/components/dialogs/createCandidate.vue')
    },
    uploadCandidateComponent() {
      return () => import('@pages/job/components/dialogs/uploadCandidate.vue')
    },
    viewCompanyComponent() {
      return () => import('@pages/company/components/dialogs/view.vue')
    },
    updateCompanyComponent() {
      return () => import('@pages/company/components/dialogs/edit.vue')
    },
    jobURL () {
      return () => import('@pages/job/components/dialogs/jobURL.vue')
    },
    viewCandidateComponent() {
      return () => import('@pages/candidate/components/dialogs/view.vue')
    },
    isCandidate() {
      return !this.role_modules.some(item => item.value == 'job.submit_candidate')
    },
    moduleName() {
      return this.isCandidate ? "Application" : "Candidate"
    },
    ...mapState('auth', ['user'])
  },
  data() {
    return {
      JobID: '',
      candidates: [],
      applicantLoading:false,
      placeApplicantLoading:false,
      rejectedApplicantLoading:false,
      loadSelectCandidate:false,
      applicant: {},
      applicants:[],
      placed_applicants:[],
      rejected_applicants:[],
      applicantProgress:false,
      finalModel: {
        user:{},
        work_experiences:[],
        educations:[],
        skills:[]
      },
      is_wizard_upload_reset: false,
      is_wizard_manual_reset: false,
      is_reset_wizard: false,
      submitted: false,
      rowId: '',
      updated: false,
      job_param_url: '',
      candidateID: '',
      fields: [
        {
          key: 'title',
          label:this.$t('job.form.title.label'),
          placeholder: this.$t('job.form.title.placeholder'),
          editable: true,
          sortable: true
        },
        {
          key: 'company_id',
          label:this.$t('job.form.company.label'),
          editable: true,
          inputType: 'select',
          params: {
            endpoint:"all",
            moduleName:"company",
            trackBy:"_id",
            valueField:"_id",
            textField:"name",
          },
          subKey: 'name',
          sortable: true
        },
        {
          key: 'employment_type',
          label:this.$t('job.form.employment_type.label'),
          editable: true,
          inputType: 'select',
          params: {
            moduleName:"employment_type_options",
          },
          fieldStyle: {
            isChip: true,
            class: 'custom-chip',
            style: 'background: rgba(235, 47, 91, 0.16); color: #EB2F5B;'
          },
          sortable: true
        },
        {
          key: 'level',
          label:this.$t('job.form.experience.label'),
          editable: true,
          inputType: 'select',
          params: {
            moduleName:"levels",
          },
          sortable: true
        },
        {
          key: 'job_type',
          label:this.$t('job.form.job_type.label'),
          editable: true,
          inputType: 'select',
          params: {
            moduleName:"jobTypes",
          },
          sortable: true
        },
        {
          key: 'function_id',
          label:this.$t('job.form.function.label'),
          editable: true,
          isArray: true,
          subKey: 'name',
          inputType: 'multiselect',
          params: {
            endpoint:"all",
            moduleName:"function",
            trackBy:"_id",
            valueField:"_id",
            textField:"name",
          },
          sortable: true
        },
        // {
        //   key: 'japanese_level',
        //   label:this.$t('job.form.japanese.label'),
          // editable: true
        // },
        {
          key: 'currency_id',
          label:this.$t('job.form.currency.label'),
          editable: true,
          subKey: 'name',
          inputType: 'select',
          params: {
            endpoint:"all",
            moduleName:"currency",
            textField:"name",
            trackBy:"_id",
            valueField:"_id",
          },
          sortable: true
        },
        {
          key: 'min_salary',
          label:this.$t('job.form.min_salary.label'),
          editable: true,
          subKey: '$numberDecimal',
          isNumber: true,
          sortable: true
        },
        {
          key: 'max_salary',
          label:this.$t('job.form.max_salary.label'),
          editable: true,
          subKey: '$numberDecimal',
          isNumber: true,
          sortable: true
        },
        {
          key: 'japanese_level',
          label:this.$t('job.form.japanese.label'),
          editable: true,
          inputType: 'select',
          params: {
            moduleName:"languageLevels",
          },
          sortable: true
        },
        {
          key: 'english_level',
          label:this.$t('job.form.english.label'),
          editable: true,
          inputType: 'select',
          params: {
            moduleName:"languageLevels",
          },
          sortable: true
        },
        {
          key: 'slots',
          label:this.$t('job.form.slots.label'),
          editable: true,
          sortable: true
        },
        {
          // key: 'rate.$numberDecimal',
          key: 'rate',
          label:this.$t('job.form.commission_rate.label'),
          editable: true,
          subKey: '$numberDecimal',
          isNumber: true,
          sortable: true
        },
        {
          key: 'payment_term',
          label:this.$t('job.form.payment_term.label'),
          editable: true,
          inputType: 'select',
          params: {
            moduleName:"paymentTerms",
          },
          sortable: true
        },
        {
          key: 'city',
          label:this.$t('job.form.city.label'),
          editable: true,
          inputType: 'customselect',
          params: {
            moduleName:"cityList",
            valueField:"value",
            textField:"text",
          },
          sortable: true
        },
        {
          key: 'country',
          label:this.$t('job.form.country.label'),
          editable: true,
          sortable: true
        },
        {
          key: 'tags',
          label:this.$t('job.form.skills.label'),
          editable: true,
          inputType: 'tags',
          fieldStyle: {
            isChip: true,
            class: 'custom-chip mr-1',
            style: 'background: rgba(235, 47, 91, 0.16); color: #EB2F5B;'
          },
          subKey: 'text',
          isArray: true,
          sortable: true
        },
      ]
    }
  },
  methods:{
    onReferCandidate(val) {
      this.JobID = val
      this.finalModel.job_id = val
      this.$refs.submitCandidate.show()
    },
    onClickActions(val) {
      this.candidateID = ''
      if(val.type == 'modal') {
        this.rowId = val.data.id ? val.data.id : val.data._id ? val.data._id : ''
        this.$refs[val.method].show()
      }else if (val.type && val.type.toLowerCase() == 'ref') {
        let isEdit = !!val.isEdit
        if(isEdit) {
          this.openFormBar(val.data._id, isEdit)
        } else {
          this.$refs[val.method].show()
        }
      }else {
        if (val && val.method) {
          if(val.bool == 'createCandidate') {
            this.onCreateCandidate(val)
          } else {
            this[val.method](val)
          }
        }
      }
    },
    modeSelect(filter){
      let params = {}
      params.filter = filter && filter.bool ? filter.bool : ''
      params.job_id = this.JobID

      this.$store.dispatch('candidate/findUserCandidate', params)
      .then(res => {
        this.candidates = res.data
        if(!params.filter){
          this.$refs.modeSelect.show()
        }
      })
    },
    modeUpload(val) {
      if (val && val.bool) {
        this.$refs.createCandidate.show()
      }
      else {
        this.$refs.uploadCandidate.show()
      }
    },
    mergePartialModels(val) {
      if(!val.showError){
        if (val.isValid && val.model) {
          this.finalModel = Object.assign({}, this.finalModel, val.model)
        }
        this.finalModel.job_id = this.JobID
      }
      else{
        this.closeAllModals()
      }
    },
    onSelectCandidate(data){
      let uiid = data.bool
      this.loadSelectCandidate = true

      this.$store.dispatch('job/applyJob', { id: this.JobID, candidate_id: uiid })
      .then(res => {
        let data = { ...res.data }
        this.loadSelectCandidate = false
        this.$refs.modeSelect.hide()
        
        let { job_id } = data.application
        if(res.data.success){
          this.loadCandidate({ id: job_id })
          this.loadCandidate({ id: job_id, placed: true })
          this.loadCandidate({ id: job_id, rejected: true })
        }
        else this.load()

        this.$bvToast.toast(res.data.toastMessage, {
          title: 'Notification',
          variant:res.data.success ? 'success' : 'danger'
        })
      })
      .catch(err => error.errorHandler(err, this.$bvToast))
    },
    loadCandidate(param){
      this.applicantLoading = !param.placed && !param.rejected
      this.placeApplicantLoading = param.placed
      this.rejectedApplicantLoading = param.rejected 
      this.applicant = {}

      this.$store.dispatch('job/getApplicants', param)
      .then(res => {

        if (res && res.data) {
          if (!param.placed && !param.rejected) {
            this.applicantProgress = false
            this.applicants = res.data || []
          }
          else if (param.placed && !param.rejected) {
            this.placed_applicants = res.data || []
            this.placeApplicantLoading = false 
          }
          else if (!param.placed && param.rejected) {
            this.rejected_applicants = res.data || []
            this.rejectedApplicantLoading = false 
          }
        }
      })
    },
    resetWizard(){
      this.is_reset_wizard = !this.is_reset_wizard
    },
    closeErrorModal(){
      this.$refs.modalError.hide()
    },
    closeAllModals(){
      this.$refs.uploadCandidate.hide()
      this.$refs.createCandidate.hide()
      this.$refs.modalError.hide()
      this.$refs.modeSelect.hide()

      this.resetWizard()
    },
    onComplete(val){
      this.candidateID = val.candidateID
      this.$refs.uploadCandidate.hide()
      this.$refs.createCandidate.hide()
      this.$refs.modeSelect.hide()
      this.$refs.viewCandidate.show()

      this.$bvToast.toast(`Application was submitted!`, {
        title: 'Notification',
        variant:'success'
      })

      this.finalModel = {
        user:{},
        work_experiences:[],
        educations:[],
        skills:[]
      }

      this.$refs['uploadwizard'].reset()
      this.$refs['manualwizard'].reset()

      this.is_wizard_upload_reset = !this.is_wizard_upload_reset
      this.is_wizard_manual_reset = !this.is_wizard_manual_reset
      this.resetWizard()

      this.loadCandidate({ id: this.jobID })
      this.loadCandidate({ id: this.jobID, placed: true })
      this.loadCandidate({ id: this.jobID, rejected: true })
    },
    onViewCompany(companyID, jobID) {
      this.finalModel.job_id = jobID
      this.rowId = companyID
      this.$refs.viewCompany.show()
    },
    onSendLink(val) {
      this.$bvModal.msgBoxConfirm('Please confirm that you want to send link to the company(this will use company email and will be sending a temporary link for company view).', {
        titleHtml: '<i class="uil uil-exclamation-triangle text-warning"></i> Please Confirm Action',
        size: 'md',
        buttonSize: 'sm',
        okVariant: 'success',
        okTitleHtml: '<i class="uil uil-message"></i> SEND LINK',
        cancelTitle: 'CANCEL',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
      })
      .then(res => {
        if(res == true){
          let id = val._id ? val._id : val.id ? val.id : this.rowId
          this.$store.dispatch('company/sendLink', { id })
          .then(res => {
            if(res.data.success){
              this.$bvToast.toast(`Successfully sent to the company!`, {
                title: 'Notification',
                variant:'success'
              })
            }
          })
        }
      })
      .catch(err => error.errorHandler(err, this.$bvToast))
    },
    onUpdateCompany(val) {
      this.updated = true
      let model = val && val.model && Object.entries(val.model).length ? val.model : val
      const objParam = ['industry_id', 'function_id', 'rate', 'source_company']

      val.validateForm && val.validateForm()
      if (val.$v && val.$v.$error) {
        this.updated = false;
        return error.errorHandler({ message: "Required field(s) must not be empty" }, this.$bvToast)
      }

      if (model && model.avatar_path && typeof model.avatar_path == 'object') {
        let data = { ...model }
        model = new FormData()

        for (let key in data) {
          if (objParam.includes(key)) model.append(key, JSON.stringify(data[key]))
          else model.append(key, data[key])
        }
      }

      model.id = val.model._id ? val.model._id : val.model.id ? val.model.id : ''
      return this.$store.dispatch('company/update', model)
      .then(result => {
        if (result && result.data) {
          this.$refs.updateCompany.hide()
          this.$refs.list.fetchData()
          this.submitted = !this.submitted
          this.$bvToast.toast(`${result.data.name} successfully updated!`, {
            title: "Notification",
            variant: "success"
          })
          setTimeout(() => {
            this.updated = false;
          }, 1500)
        }
      })
      .catch(err => {
        this.updated = false;
        return error.errorHandler(err, this.$bvToast);
      })
    },
    onCloseModal(modal){
      this.$refs[modal.bool].hide()
    },
    urlGenerate(jobID, company = false){
      return this.$store.dispatch('job/generateUrl', { id: jobID, company })
      .then(res => {
        if (res && res.data) {
          this.$refs.showGeneratedURL.show();
          this.job_param_url = res.data;

          this.$emit('onGenerateUrl', { id: jobID, url: res.data, is_company: company })
        }
      })
      .catch(err => {
        console.log("FATAL ERROR: ", err)
        return error.errorHandler(err, this.$bvToast)
      })
    },
    onCopyUrl(job_url) {
      this.job_param_url = job_url
      this.$refs.showGeneratedURL.show()
    },
    onActivate (job) {
      this.$bvModal.msgBoxConfirm('Are you sure you want to ' + (job.active ? 'Deactivate' : 'Activate'), {
        title: 'Please Confirm Action',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'success',
        okTitle: 'YES',
        cancelTitle: 'NO',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
      })
      .then(res => {
        if(res == true){
          this.$store.dispatch('job/activate', job)
          .then(res => {
            this.$emit("fetchData")
            this.$bvToast.toast(`Job #${res.data.reference_no} has been ${res.data.active ? 'Activated' : 'Deactivated'}!`, {
              title: 'Notification',
              variant:'success'
            })
          })
          .catch(err => error.errorHandler(err, this.$bvToast))
        }
      })
      .catch(err => error.errorHandler(err, this.$bvToast))
    },
    onPublish(job){
      this.$bvModal.msgBoxConfirm(`Please confirm that you want to ${!job.published ? 'post' : 'unpost' } this job (this action is one time only).`, {
        title: 'Please Confirm Action',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'success',
        okTitle: 'YES',
        cancelTitle: 'NO',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
      })
      .then(res => {
        if(res == true){
          this.toggleLoading()
          this.$store.dispatch('job/publishJob', {
            id:job._id,
            published: !job.published
          })
          .then(res => {
            if(res.data.published || !res.data.published){
              this.$bvToast.toast(`Job #${res.data.reference_no} has been ${!res.data.published ? 'posted' : 'unposted' }!`, {
                title: 'Notification',
                variant:'success'
              })

              this.$emit("fetchData")
              // this.loadCandidate()
              this.toggleLoading()
            }
          }).catch(err => error.errorHandler(err, this.$bvToast))
        }
      })
      .catch(err => error.errorHandler(err, this.$bvToast))
    },
    onClickEdit(jobID) {
      this.$router.push({path: '/job/edit', query: { id: jobID }})
    },
    modifiedJobDate(date) {
      return date ? moment(date).format('YYYY-MM-DD hh:mm:ss A') : '-'
    },
    async onCreateCandidate(val) {
      if(val.isCreated) {
        this.$bvToast.toast('Candidate successfully updated!', {
          variant: 'success',
          title: "Notification"
        })
      }
      this[val.method](val)

      if(this.candidateID) {
        await this.$refs.viewCandidate.hide()
      }

      if(val.candidateID) {
        this.openFormBar(val.candidateID)
      }
		},
    openFormBar(id, editMode = false) {
      this.candidateID = id
      if (!editMode) {
        this.$refs.viewCandidate.show()
      } else {
        this.$refs.createCandidate.show()
      }
    },
    sortChanged(e){
      this.$emit('sortChange', { ...e })
    },
  },
  mounted(){

  }
}
</script>
<style lang="scss">
.customDialog > div {
  position: absolute;
  width: 592px !important;
  /* height: 1024px !important; */
  /* left: 848px !important; */
  right: 0px;
  top: 0px;
}

.customDialog > .modal-dialog > .modal-content {
  background: #FFFFFF;
  box-shadow: 2px 4px 24px rgba(0, 0, 0, 0.25);
}

.badge-matched {
  background-color: rgba(235, 47, 91, 0.2);
  color: #EB2F5B;
}
</style>